export default __webpack_public_path__ + "cart-success.svg?d451e0d01cdbc066e11a0b5d29329226";